import axios from 'axios'
export function getClientVersion() {
  let path = `/version.txt`
  return axios.get(path)
    .then(r => r.data)
    .catch(e => {
      console.error(e)
      return null
    })
}



// WEBPACK FOOTER //
// ./react/api/version.ts